import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next";

const Tr = (props) => {
    const { t } = useTranslation();
    const { shop } = useParams();
    const tx = props.tx;

    const stateLabel = t(`draw_transactions.state_${tx.state}`, tx.state || '');
    const refundLabel = tx.refund_state ? t(`draw_transactions.refund_${tx.refund_state}`, tx.refund_state) : '-';

    return (
        <tr>
            <td>{tx.order_no}</td>
            <td>
                {tx.package_id
                    ? <Link to={'/' + shop + '/oripa/' + tx.package_id}>{tx.package ? tx.package.name : tx.package_id}</Link>
                    : '-'}
            </td>
            <td>{tx.user_id}</td>
            <td><span className={`badge badge-${tx.state}`}>{stateLabel}</span></td>
            <td>{tx.total_pt}</td>
            <td>{tx.consumed_pt}</td>
            <td>{tx.cash_paid_cny}</td>
            <td>{tx.rate_snapshot}</td>
            <td>{refundLabel}</td>
            <td>{tx.wechat_transaction_id || '-'}</td>
            <td>{tx.created_at ? (new Date(tx.created_at)).toLocaleString() : '-'}</td>
        </tr>
    )
}

export default Tr
